<template>
  <!-- TODO: переписать классы на БЭМ, убрать специфичность селекторов -->
  <div class="investmentCooperationRussia">
    <div class="investmentCooperationRussia__climate">
      <span class="investmentCooperationRussia__headTitle">Инвестиции и инвестиционный климат</span>
      <div class="investmentCooperationRussia__climate__ratingBlock">
        <span class="investmentCooperationRussia__headTitle">Кредитный рейтинг</span>
        <Tooltip :triggers="['click']" class="tooltip-component--mobile-big">
          <span class="investmentCooperationRussia__helpButton__text">
            Moody’s / S&P / Fitch. Зеленый цвет — инвестиционный рейтинг, темно-оранжевый — спекулятивный.
          </span>
        </Tooltip>
        <p v-if="isNotEmptyCountryCreditRating" class="investmentCooperationRussia__climate__ratingBlock__info">
          <span :class="countryCreditRatingClass.moody">{{ countryCreditRating.moody || '–' }}</span>
          <span>/</span><span :class="countryCreditRatingClass.snP">{{ countryCreditRating.snP || '–' }}</span
          ><span>/</span><span :class="countryCreditRatingClass.dbrs">{{ countryCreditRating.dbrs || '–' }}</span>
        </p>
        <p
          v-else
          class="investmentCooperationRussia__climate__ratingBlock__info investmentCooperationRussia__ratingBlock--gray"
        >
          Нет данных
        </p>
      </div>
    </div>

    <PIIChart :countryId="countryId" :summary="summary" :countryData="countryData" />

    <div v-if="isShowIndustryInvestmentsBlock" class="investmentCooperationRussia__investmentDirections">
      <span class="investmentCooperationRussia__headTitle"
        >Основные направления инвестирования в Россию в {{ exportData.reportYear }} году</span
      >
      <div
        class="investmentCooperationRussia__investmentDirections__contentBlock"
        v-if="topThreeIndustries?.industriyInvestments?.length"
      >
        <ul class="investmentCooperationRussia__investmentDirections__contentBlock__itemsBlock">
          <li
            class="investmentCooperationRussia__investmentDirections__contentBlock__itemsBlock__item"
            v-for="item in topThreeIndustries.industriyInvestments"
            :key="item"
          >
            {{ item.name }} ({{ convertAmount(item.value) }})
          </li>
        </ul>
      </div>
      <div class="investmentCooperationRussia__noData" v-else>Нет данных</div>
    </div>

    <div v-if="isShowTopFiveInvestorsBlock" class="investmentCooperationRussia__leadingInvestors">
      <span class="investmentCooperationRussia__headTitle"
        >Топ-5 стран инвесторов в {{ countryData?.accusativeCase }} в {{ exportData.reportYear }} году, млрд $</span
      >
      <div class="investmentCooperationRussia__leadingInvestors__contentBlock">
        <EChartsVerticalBar
          :labels="leadingInvestorsChartLabels"
          :dataset="leadingInvestorsChartDataset"
          :valueFractionDigits="1"
          :height="400"
          :legendSelectable="false"
          yAxisName="Млрд $"
          :yAxisMaxRatio="1.1"
          :barMaxWidth="40"
        />
      </div>
    </div>

    <div class="investmentCooperationRussia__tradingServices">
      <span class="investmentCooperationRussia__headTitle">
        Торговля услугами России с {{ countryData.instrumentalCase }} в {{ exportData.reportYear }} году
      </span>
      <div class="investmentCooperationRussia__tradingServices__contentBlock" v-if="tradServExpChartLabels.length">
        <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock">
          <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock">
            <span class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock__text">
              Экспорт&emsp;{{ convertAmount(exportData.totalValue) }} </span
            >&emsp;
            <span
              :class="`investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock__text
              ${getDifferenceColor(exportData.difference)}`"
            >
              {{ getDifference(exportData.difference) }}% г/г
            </span>
          </div>
          <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__chart">
            <EChartsHorizontalBar
              v-if="tradServExpChartLabels.length"
              :height="400"
              :valueFractionDigits="1"
              :barMaxWidth="20"
              :categoryLabelWidth="280"
              :xAxisMaxRatio="1.2"
              :labels="tradServExpChartLabels"
              :dataset="tradServExpChartDataset"
            />
          </div>
        </div>
        <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock">
          <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock">
            <span class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock__text">
              Импорт&emsp;{{ convertAmount(importData.totalValue) }} </span
            >&emsp;
            <span
              :class="`investmentCooperationRussia__tradingServices__contentBlock__chartBlock__infoBlock__text
              ${getDifferenceColor(exportData.difference)}`"
            >
              {{ getDifference(importData.difference) }}% г/г
            </span>
          </div>
          <div class="investmentCooperationRussia__tradingServices__contentBlock__chartBlock__chart">
            <EChartsHorizontalBar
              v-if="tradServImpChartLabels.length"
              :height="400"
              :valueFractionDigits="1"
              :barMaxWidth="20"
              :categoryLabelWidth="280"
              :xAxisMaxRatio="1.2"
              :labels="tradServImpChartLabels"
              :dataset="tradServImpChartDataset"
            />
          </div>
        </div>
      </div>
      <div class="investmentCooperationRussia__noData" v-else>Нет данных</div>
    </div>
  </div>
</template>

<script>
  import Constants from '@/common/constants';
  import text from '@/common/mixins/text';
  import Tooltip from '@/common/ui/Tooltip.vue';
  import { numberFormatter } from '@/common/utils/numberFormatter';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import Api from '../../api';
  import {
    DbrsInvestRatings,
    DIVIDER_LABEL,
    DIVIDER_LABEL_MILLARD,
    MoodyInvestRatings,
    SnPInvestRatings,
  } from '../../utils/constants.js';
  import PIIChart from '../PIIChart.vue';

  export default {
    name: 'InvestmentCooperationRussia',

    components: {
      PIIChart,
      EChartsHorizontalBar,
      EChartsVerticalBar,
      Tooltip,
    },

    mixins: [text],

    props: {
      countryId: {
        type: String,
        default: '',
      },
      summary: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        exportData: {},
        importData: {},
        countryCreditRating: {
          moody: null,
          snP: null,
          dbrs: null,
        },
        topThreeIndustries: {},
        topFiveInvestors: [],
        countryData: {},
      };
    },

    created() {
      this.loadData();
    },

    watch: {
      countryId: function () {
        this.loadData();
      },
    },

    computed: {
      tradServExpChartLabels() {
        return this.buildTradeServicesChartLabels(this.exportData);
      },

      tradServExpChartDataset() {
        return this.buildYearComparisonDataset(this.exportData);
      },

      tradServImpChartLabels() {
        return this.buildTradeServicesChartLabels(this.importData);
      },

      tradServImpChartDataset() {
        return this.buildYearComparisonDataset(this.importData);
      },

      isShowIndustryInvestmentsBlock() {
        return !!this.topThreeIndustries?.industriyInvestments?.length;
      },

      isShowTopFiveInvestorsBlock() {
        return !!this.topFiveInvestors.length || this.isEmptyInvestors;
      },

      isEmptyInvestors() {
        return !this.topThreeIndustries?.industriyInvestments?.length && !this.topFiveInvestors.length;
      },

      isNotEmptyCountryCreditRating() {
        const { moody, snP, dbrs } = this.countryCreditRating;
        return moody || snP || dbrs;
      },
      countryCreditRatingClass() {
        const { moody, snP, dbrs } = this.countryCreditRating;
        return {
          moody: this.getCreditRatingTextClass(moody, MoodyInvestRatings),
          snP: this.getCreditRatingTextClass(snP, SnPInvestRatings),
          dbrs: this.getCreditRatingTextClass(dbrs, DbrsInvestRatings),
        };
      },
      getLeadingInvestors() {
        const data = {
          data: [],
          labels: [],
        };

        this.topFiveInvestors.forEach((country) => {
          data.labels.push(country.countryName);
          data.data.push((country.amount / 1000).toFixed(1));
        });

        return data;
      },
      leadingInvestorsChartLabels() {
        return this.getLeadingInvestors.labels;
      },
      leadingInvestorsChartDataset() {
        return [
          {
            label: '',
            data: this.getLeadingInvestors.data.map((value) => Number(value)),
            color: '#0093BA',
          },
        ];
      },
    },

    methods: {
      loadData() {
        this.topFiveInvestors = [];

        Api.getCountryCreditRating(this.countryId)
          .then((response) => {
            const data = response?.data;
            if (data) {
              if (data.moody || data.snP || data.dbrs) {
                this.countryCreditRating.moody = data?.moody ?? '';
                this.countryCreditRating.snP = data?.snP ?? '';
                this.countryCreditRating.dbrs = data?.dbrs ?? '';
              }
            }
          })
          .catch((err) => {
            console.error(err);
            this.countryCreditRating = {
              moody: null,
              snP: null,
              dbrs: null,
            };
          });

        Api.getTopThreeIndustries(this.countryId)
          .then((response) => {
            this.topThreeIndustries = response?.data;

            if (!this.topThreeIndustries?.industriyInvestments?.length) {
              this.initTopFiveInvestors();
            }
          })
          .catch((err) => {
            console.error(err);
            this.topThreeIndustries = {};
            this.initTopFiveInvestors();
          });

        Api.getFavorTrade(this.countryId, true)
          .then((response) => {
            this.exportData = response?.data;
          })
          .catch((err) => {
            console.error(err);
            this.exportData = {};
          });

        Api.getFavorTrade(this.countryId, false)
          .then((response) => {
            this.importData = response?.data;
          })
          .catch((err) => {
            console.error(err);
            this.importData = {};
          });

        Api.findCountry(this.countryId)
          .then((response) => {
            this.countryData = response?.data;
          })
          .catch((err) => {
            console.error(err);
            this.countryData = {};
          });
      },

      async initTopFiveInvestors() {
        try {
          const response = await Api.getTopFiveInvestors(this.countryId);
          this.topFiveInvestors = response?.data?.investmentData ?? [];
        } catch (err) {
          console.error(err);
          this.topFiveInvestors = [];
        }
      },

      convertAmount(val) {
        const calculatedValue = val >= 1 ? val : val * Constants.THOUSAND;
        const divider = val >= 1 ? DIVIDER_LABEL_MILLARD : DIVIDER_LABEL;

        return `${this.formatNumber(calculatedValue, 1, ' ', ',', true)} ${divider} $`;
      },
      getDifference(val) {
        const valueFix = numberFormatter(val, 'ru-RU', 1);
        return val > 0 ? `+${valueFix}` : valueFix;
      },

      getDifferenceColor(val) {
        return val > 0 ? 'green' : val == 0 ? 'gray' : 'red';
      },
      getCreditRatingTextClass(ratingValue, investRatingsReferenceList) {
        if (!ratingValue) return 'investmentCooperationRussia__ratingBlock--gray';
        return investRatingsReferenceList.includes(ratingValue)
          ? 'investmentCooperationRussia__ratingBlock--green'
          : 'investmentCooperationRussia__ratingBlock--orange';
      },

      buildYearComparisonDataset(tradeData) {
        if (!tradeData?.currentPeriod?.length) return [];

        return [
          {
            label: this.buildYearSeriesLabel(tradeData.reportYear),
            data: this.mapPeriodToChartValues(tradeData.currentPeriod),
            color: '#0393BA',
          },
          {
            label: this.buildYearSeriesLabel(tradeData.previousReportYear),
            data: this.mapPeriodToChartValues(tradeData.previousPeriod),
            color: '#D1D5DB',
          },
        ];
      },

      mapPeriodToChartValues(period) {
        return (period ?? []).map((item) => Number(item.value.toFixed(1)));
      },

      buildYearSeriesLabel(year) {
        if (year == null || year === '') return '';

        return `${year}, млн $`;
      },

      buildTradeServicesChartLabels(tradeData) {
        return (tradeData?.currentPeriod ?? []).map((item) => item.name || '');
      },
    },
  };
</script>

<style lang="scss">
  .investmentCooperationRussia {
    display: flex;
    flex-direction: column;
    gap: 40px;

    &__headTitle {
      font: $fira-20-M;
      color: $base;
      margin: 0 0 24px 0;
    }

    &__helpButton {
      .tooltip-component__content {
        &__text {
          font: $fira-14;
        }
      }
    }

    &__ratingBlock {
      &--gray {
        // TODO: после переписывания на бэм !important можно убрать
        color: $dark-grey-1 !important;
      }

      &--green {
        color: $approval-text !important;
      }

      &--orange {
        color: $rating-warn !important;
      }
    }

    &__climate {
      display: flex;
      flex-direction: column;

      &__ratingBlock {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
        gap: 16px 8px;

        & .investmentCooperationRussia__headTitle {
          margin: 0;
        }

        & .investmentCooperationRussia__helpButton {
          margin: 0 16px 0 8px;
        }

        &__info,
        &__info > span {
          font: $fira-20-M;
          color: $base;
        }
      }
    }

    &__inRussiaRatingBlock {
      display: flex;
      flex-direction: column;
      width: 100%;

      & .chartBar {
        width: 100%;
      }

      &__contentBlock {
        display: flex;
        width: 100%;
        gap: 16px;

        &__rating {
          flex: 1;
          width: 100%;

          @media screen and (max-width: $tablet) {
            overflow: hidden;
            overflow-x: auto;
          }
        }

        &__infoBlock {
          display: flex;
          flex-direction: column;
          gap: 16px;
          flex: 1;

          &__title {
            font: $fira-16;
            color: $base;
          }
        }

        @media screen and (max-width: $tablet) {
          flex-direction: column;
        }
      }
    }

    &__investmentDirections {
      width: 100%;
      display: flex;
      flex-direction: column;

      &__contentBlock {
        width: 100%;

        &__itemsBlock {
          list-style: inside;
          display: flex;
          flex-direction: column;
          gap: 10px;

          &__item {
            font: $fira-20-M;
            color: #17a1fa;
          }
        }
      }
    }

    &__tradingServices {
      width: 100%;
      display: flex;
      flex-direction: column;

      &__contentBlock {
        display: flex;
        align-items: flex-start;

        &__chartBlock {
          display: flex;
          flex-direction: column;
          gap: 16px;
          flex: 1;

          &__infoBlock {
            display: flex;
            gap: 5px;

            &__text {
              font: $fira-20-M;
              color: $blue;

              .green {
                color: $green;
              }

              .red {
                color: $red;
              }

              .gray {
                color: $light-grey-5;
              }
            }
          }

          &__chart {
            @media screen and (max-width: 1280px) {
              overflow: hidden;
            }
          }

          @media screen and (max-width: 1280px) {
            width: 100%;
          }
        }

        @media screen and (max-width: 1280px) {
          flex-direction: column;
          gap: 24px;
        }
      }
    }

    &__leadingInvestors {
      display: flex;
      flex-direction: column;
      overflow-x: auto;
      padding: 0 0 10px 0;

      &__contentBlock {
        width: 768px;
      }

      & .chartBar {
        width: 100%;
      }
    }
  }
</style>
